import { createFileRoute, redirect } from '@tanstack/react-router'
import { StatementScreen } from '@/features/accounting-statements/statement-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/accounting/statements')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'accounting_report.view'))
      throw redirect({ to: '/accounting' })
  },
  component: StatementScreen,
})
